import { ReactElement } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { ScreenTitle } from '../../components/screen-title/screen-title'

const ProfileScreen = (): ReactElement => {
  return (
    <Flexbox isCol flex={1}>
      <ScreenTitle title={'Profile'} />
      <p>
        No profile info yet. <strong>1101 Capital</strong>
      </p>
    </Flexbox>
  )
}

export default ProfileScreen